import React from 'react';

const Symbiosis = ({ data }) => {
    const networks = {
        base: {
            name: 'Base',
            USDC: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913'
        },
        solana: {
            name: 'Solana',
            USDC: '0x0000000000000000000000000000000000000003'
        },
        polygon: {
            name: 'Polygon',
            USDT: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
            USDC: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359'
        },
        optimism: {
            name: 'Optimism',
            USDT: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
            USDC: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85'
        },
        arbitrum: {
            name: 'Arbitrum%20One',
            USDT: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
            USDC: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831'
        }
    };

    return (
        <iframe id="widget__iframe" height="610px" width="420px"
            src={`https://app.symbiosis.finance/swap?chainIn=TON&chainOut=${networks[data.name].name}&tokenIn=0x9328Eb759596C38a25f59028B146Fecdc3621Dfe&tokenOut=${networks[data.name][data.coin]}`}
            style={{
                border: 'none',
                borderRadius: '11px',
                boxShadow: '3px 3px 10px 4px rgba(0, 0, 0, 0.05)'
            }}>
        </iframe>
    );
};

export default Symbiosis;
